// extracted by mini-css-extract-plugin
module.exports = {"label":"Checkbox_label__j5Wnc","checkbox":"Checkbox_checkbox__3cbdZ"};